var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isFiMenu)?_c('InstitutionsDashboard'):_c('VendorsAdvisorsDashboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }